/*
* Palo Alto Theme - custom.js (Performance Fix v2)
*/

(function() {

  // ─── 0. CRITICAL CSS ─────────────────────────────────────────────────────
  var style = document.createElement('style');
  style.textContent = [

    /* Botão Add to Cart */
    '[data-add-to-cart], .beez-atc, [name="add"],',
    'button[type="submit"].btn--add-to-cart, .product-form__submit {',
    '  background-color: #011C45 !important;',
    '  border-color: #011C45 !important;',
    '  color: #fff !important;',
    '}',
    '[data-add-to-cart]:hover, .beez-atc:hover, [name="add"]:hover,',
    'button[type="submit"].btn--add-to-cart:hover, .product-form__submit:hover {',
    '  background-color: #0a2d66 !important;',
    '  border-color: #0a2d66 !important;',
    '  color: #fff !important;',
    '}',

    /* Remove loading screen imediatamente */
    '.loading-overlay { display: none !important; }',

    /* Seções visíveis sem aguardar scroll */
    '.animate-section.animate--hidden {',
    '  opacity: 1 !important;',
    '  transform: none !important;',
    '  visibility: visible !important;',
    '}',
    '.animate-item.animate-item--child {',
    '  opacity: 1 !important;',
    '  transform: none !important;',
    '  visibility: visible !important;',
    '}',

    /* Esconde Shop Pay / PayPal / GPay no drawer */
    '.cart-drawer [data-additional-checkout-button],',
    '.cart-drawer .additional-checkout-buttons {',
    '  display: none !important;',
    '}',
    '.cart-drawer [data-cart-checkout-button] {',
    '  padding-bottom: 20px;',
    '}'

  ].join('\n');
  document.head.appendChild(style);

  // ─── 1. REMOVE LOADING SCREEN ────────────────────────────────────────────
  document.documentElement.classList.remove('is-loading');
  document.documentElement.classList.add('is-loaded');

  // ─── 2. REVEAL SECTIONS (sem aguardar scroll) ────────────────────────────
  // NÃO toca em imagens — só remove classes de animação de seções
  function revealAllSections() {
    document.querySelectorAll(
      '.animate-section.animate--hidden, [data-aos]:not(.aos-animate)'
    ).forEach(function(el) {
      el.classList.remove('animate--hidden');
      el.classList.add('animate--visible', 'aos-animate');
    });
  }

  document.addEventListener('DOMContentLoaded', revealAllSections);
  window.addEventListener('load', revealAllSections);
  setTimeout(revealAllSections, 600);
  setTimeout(revealAllSections, 1500);

  // ─── 3. ABRIR CART DRAWER ────────────────────────────────────────────────
  var _drawerTimer = null;

  function openCartDrawer() {
    if (_drawerTimer) clearTimeout(_drawerTimer);
    _drawerTimer = setTimeout(function() {
      document.dispatchEvent(new CustomEvent('cart:open', { bubbles: true }));
      document.dispatchEvent(new CustomEvent('theme:cart:open', { bubbles: true }));

      setTimeout(function() {
        var drawerOpen = document.querySelector(
          '.cart-drawer--is-open, [data-drawer].is-open'
        );
        if (!drawerOpen) {
          var triggers = [
            '[data-cart-trigger]',
            '[data-drawer-toggle="cart"]',
            '.cart__toggle',
            '[data-toggle="cart"]'
          ];
          for (var i = 0; i < triggers.length; i++) {
            var el = document.querySelector(triggers[i]);
            if (el) { el.click(); break; }
          }
        }
      }, 200);
    }, 100);
  }

  // ─── 4. EVENTOS CART ─────────────────────────────────────────────────────
  document.addEventListener('cart:updated', openCartDrawer);
  document.addEventListener('theme:cart:updated', openCartDrawer);

  // ─── 5. INTERCEPT XHR (Beez usa XHR) ────────────────────────────────────
  var _XHRopen = XMLHttpRequest.prototype.open;
  var _XHRsend = XMLHttpRequest.prototype.send;

  XMLHttpRequest.prototype.open = function(method, url) {
    this._url = url || '';
    return _XHRopen.apply(this, arguments);
  };

  XMLHttpRequest.prototype.send = function() {
    var xhr = this;
    if (xhr._url && xhr._url.indexOf('/cart/add') !== -1) {
      xhr.addEventListener('load', function() {
        if (xhr.status >= 200 && xhr.status < 300) {
          try {
            var data = JSON.parse(xhr.responseText);
            if (data && (data.items || data.id || data.line_price !== undefined)) {
              openCartDrawer();
            }
          } catch(e) {
            openCartDrawer();
          }
        }
      });
    }
    return _XHRsend.apply(this, arguments);
  };

  // ─── 6. POLLING CART COUNT ───────────────────────────────────────────────
  var _lastCartCount = -1;

  window.addEventListener('load', function() {
    _lastCartCount = getCartCount();
    setInterval(function() {
      var current = getCartCount();
      if (current > _lastCartCount && _lastCartCount >= 0) openCartDrawer();
      if (current >= 0) _lastCartCount = current;
    }, 500);
  });

  function getCartCount() {
    var el = document.querySelector(
      '[data-cart-count], .cart-count, .js-cart-count, [data-item-count]'
    );
    if (!el) return -1;
    var n = parseInt(el.textContent.trim(), 10);
    return isNaN(n) ? 0 : n;
  }

  // ─── 7. UPDATE PRICE DISPLAY ─────────────────────────────────────────────
  function formatMoney(cents) {
    var symbol = (window.Shopify && window.Shopify.currency && window.Shopify.currency.symbol) || '£';
    return symbol + (cents / 100).toFixed(2);
  }

  function updatePriceDisplay() {
    var priceEl = document.getElementById('mv-price');
    if (!priceEl) return;

    var selectors = [
      '.bsb-option--selected [data-price]',
      '.bsb-option--selected .bsb-price',
      '[data-beez-selected] [data-price]',
      '.beez-bundle-option.active [data-price]',
      '[class*="bundle"][class*="selected"] [data-price]'
    ];

    var found = null;
    for (var i = 0; i < selectors.length; i++) {
      found = document.querySelector(selectors[i]);
      if (found) break;
    }

    if (found) {
      var raw = found.getAttribute('data-price') || found.textContent;
      var numeric = parseFloat(raw.replace(/[^0-9.]/g, ''));
      if (!isNaN(numeric)) {
        priceEl.textContent = formatMoney(numeric * 100);
      }
    }
  }

  document.addEventListener('change', function() { setTimeout(updatePriceDisplay, 200); });
  document.addEventListener('click', function(e) {
    if (e.target && e.target.closest &&
        e.target.closest('[class*="bundle"], [class*="beez"], [class*="bsb"]')) {
      setTimeout(updatePriceDisplay, 300);
    }
  });

  setTimeout(updatePriceDisplay, 1000);
  setTimeout(updatePriceDisplay, 2500);

})();
